import { render, staticRenderFns } from "./GrossMarginCalculator.vue?vue&type=template&id=13772a18&scoped=true"
import script from "./GrossMarginCalculator.vue?vue&type=script&lang=js"
export * from "./GrossMarginCalculator.vue?vue&type=script&lang=js"
import style0 from "./GrossMarginCalculator.vue?vue&type=style&index=0&id=13772a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13772a18",
  null
  
)

export default component.exports